import Link from 'next/link';
import styled from 'styled-components';
import { FlexColumn } from '../../../../../styled/common';
import { Typography } from '../../../../ui/Typography';

export const TermsAndConditionContainer = styled(FlexColumn)`
  gap: 15px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    flex-direction: row-reverse;
    padding: 0;
  }
`;

export const Terms = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    text-align: left;
  }
`;

export const StyledLink = styled(Link)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
